/**
 * Feature flags for controlling page visibility.
 * Set via environment variables (VITE_FEATURE_*) or defaults to enabled.
 *
 * To disable a feature, set the environment variable to 'false':
 *   VITE_FEATURE_GALLERY=false
 *   VITE_FEATURE_REGISTRY=false
 *   VITE_FEATURE_RSVP=false
 */

export const featureFlags = {
  gallery: import.meta.env.VITE_FEATURE_GALLERY?.trim() !== 'false',
  registry: import.meta.env.VITE_FEATURE_REGISTRY?.trim() !== 'false',
  rsvp: import.meta.env.VITE_FEATURE_RSVP?.trim() !== 'false',
} as const;

export type FeatureFlag = keyof typeof featureFlags;
